import React from 'react';
import { Button } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { getFrontUrl } from '../helpers';

const ChangeFlights = ({ history, location: { pathname, search } }) => (
  <div
    role="button"
    aria-label="Change Flights"
    onClick={() => {
      history.push({ pathname: getFrontUrl(pathname, 2), search });
    }}
  >
    <Button color="trans">
      <i className="icon icon-hg-chev-left" /> Change Flight
    </Button>
  </div>
);

export default withRouter(ChangeFlights);



// WEBPACK FOOTER //
// ./src/screens/Flights/Common/ChangeFlightsButton.js